const $inject = [];

const toAddressFilter = () => {
  return (addressObject) => {
    if(!addressObject) {
      return '';
    }

    let addressFields = [];

    if(addressObject.Address) {
      addressFields.push(addressObject.Address);
    }

    if(addressObject.City) {
      addressFields.push(addressObject.City);
    }

    if(addressObject.State) {
      addressFields.push(addressObject.State);
    }

    if(addressObject.Country && addressObject.Country.Name) {
      addressFields.push(addressObject.Country.Name);

      if(addressObject.Postcode) {
        addressFields[addressFields.length - 1] = addressFields[addressFields.length - 1] + ' ' + addressObject.Postcode;
      }
    } else if(addressObject.Postcode) {
      addressFields.push(addressObject.Postcode);
    }

    return addressFields.join(', ');
  }
};

toAddressFilter.$inject = $inject;

export default toAddressFilter;



// WEBPACK FOOTER //
// ./src/filters/toAddressFilter.js